/** Requested top corner radius — clamped per bar when height is shorter. */
export const BAR_TOP_RADIUS = 10;

export function clampBarTopRadius(
  height: number,
  width: number,
  maxRadius = BAR_TOP_RADIUS,
): number {
  if (height <= 0 || width <= 0) return 0;
  return Math.min(maxRadius, height, width / 2);
}

/** SVG path for a bar with rounded top corners only; bottom stays square on the axis. */
export function roundedTopBarPath(
  x: number,
  y: number,
  width: number,
  height: number,
  maxRadius = BAR_TOP_RADIUS,
): string {
  if (height <= 0 || width <= 0) return "";
  const radius = clampBarTopRadius(height, width, maxRadius);
  const right = x + width;
  const bottom = y + height;

  if (radius <= 0) {
    return `M ${x} ${y} H ${right} V ${bottom} H ${x} Z`;
  }

  return [
    `M ${x + radius} ${y}`,
    `H ${right - radius}`,
    `A ${radius} ${radius} 0 0 1 ${right} ${y + radius}`,
    `V ${bottom}`,
    `H ${x}`,
    `V ${y + radius}`,
    `A ${radius} ${radius} 0 0 1 ${x + radius} ${y}`,
    "Z",
  ].join(" ");
}
